import { render } from "./ChangeSelfPassword.vue?vue&type=template&id=4735ab2f"
import script from "./ChangeSelfPassword.vue?vue&type=script&lang=js"
export * from "./ChangeSelfPassword.vue?vue&type=script&lang=js"

import "./ChangeSelfPassword.vue?vue&type=style&index=0&id=4735ab2f&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__